import {Component, OnInit} from '@angular/core';
import {StepperComponent} from "./components/stepper/stepper.component";
import {FormComponent} from "./components/form/form.component";
import {select, Store} from "@ngrx/store";
import {selectCurrentStep, selectShowSummary} from "../../store/reservationForm/stepper.selector";
import {Observable, Subscription} from "rxjs";
import {AsyncPipe, NgClass, NgIf} from "@angular/common";
import {AuthService} from "../../core/services/auth/auth.service";
import {AuthStateService} from "../../core/services/auth/auth-state.service";
import {User} from "../../models/User";
import {SummaryComponent} from "./components/summary/summary.component";
import {updateShowSummary} from "../../store/reservationForm/stepper.actions";
import {RouterLink} from "@angular/router";
import {Formv2Component} from "./components/formv2/formv2.component";
import {Stepperv2Component} from "./components/stepperv2/stepperv2.component";
import {Summaryv2Component} from "./components/summaryv2/summaryv2.component";
import {BookFormService} from "../../core/services/book-form.service";

@Component({
  selector: 'app-front',
  standalone: true,
  imports: [
    StepperComponent,
    FormComponent,
    AsyncPipe,
    NgIf,
    SummaryComponent,
    NgClass,
    RouterLink,
    Formv2Component,
    Stepperv2Component,
    Summaryv2Component
  ],
  templateUrl: './front.component.html',
  styleUrl: './front.component.css'
})
export class FrontComponent{
  currentStep: number = 1;
  user: User|null = null;
  showSummary: boolean=false;

  constructor(private store: Store, public authService: AuthStateService, private bookFormService: BookFormService, ) {
    /*this.currentStep$ = this.store.pipe(select(selectCurrentStep));
    this.currentStep$.subscribe(step => {
      this.currentStep = step;
    });
    this.showSummary$ = this.store.pipe(select(selectShowSummary));
    this.showSummary$.subscribe(showSummary => {
      this.showSummary = showSummary;
    })*/

    this.bookFormService.reservationForm$.subscribe({
      next: value => {
        this.currentStep = value.step;
        this.showSummary = value.showSummary;
      }
    })


    this.authService.currentUser.subscribe(user => {
      this.user = user;
    })
  }

  public toggleSummary() {
    this.bookFormService.toggleSummary();
  }
}
